import React from 'react';
import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';

export default class EmptyState extends React.Component {
  render() {
    return (
      <div className="CartSidebar__empty-state">
        <h3>
          <TranslatedMessage id={'cart.empty_cart.cart_is_empty'} />{' '}
        </h3>
        <Button.KeyAction
          onClick={this.props.onClickButton}
          className="CartSidebar__button--continue-shopping"
        >
          <TranslatedMessage id={'cart.empty_cart.continue'} />
        </Button.KeyAction>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/sidebar/EmptyCart.js